<template>
    <div>
        <b-modal  v-model="modalShow" centered title="Account List" size="lg" :hide-footer="true">
          <div>
              <b-row>
                <b-colxx xxs="12" md="4">
                  <div class="form-group has-float-label">
                    <v-select size="sm" v-model="fromWh" :options="selectFrom" style="height: 30px;"/>
                    <span style="font-size:14px;">From</span>
                  </div>
                </b-colxx>
                <b-colxx xxs="12" md="6">
                  <label class="form-group has-float-label mb-4">
                    <input type="input" v-model="search" class="form-control" v-on:keyup.enter="onloadSearch()">
                    <span style="font-size:14px;">Search</span>
                  </label>
                </b-colxx>
                <b-colxx xxs="12" md="2">
                    <b-button size="sm" variant="primary" style="float: left;" @click="onloadSearch()"> <i class="simple-icon-magnifier"></i> Search</b-button>
                </b-colxx>
              </b-row>
              <b-row>
                <b-colxx xxs="12" md="12">
                  <vue-perfect-scrollbar  class="scroll dashboard-list-with-thumbs" :settings="{ suppressScrollX: true, wheelPropagation: false }">
                   <table class="tableMain">
                     <thead>
                       <tr>
                         <th style="width:70px;">ID</th>
                         <th style="width:150px;">Account Code</th>
                         <th style="width:30%">Account Name </th>
                         <th></th>
                       </tr>
                     </thead>
                     <tbody>
                       <tr  v-for="(v,i) in dataaccount" :key="i" @click="onModalReturn(v)" v-bind:class="{'classSelect':(v.select == 1)}">
                         <td style="text-align:center;">{{ skip+i+1}}</td>
                         <td style="text-align:center;"><b>{{ v.account_code }}</b></td>
                         <td>{{ v.account_name }}</td>
                         <td></td>
                       </tr>
                     </tbody>
                   </table>
                  </vue-perfect-scrollbar>

                </b-colxx>
              </b-row>
          </div>
          <div class="paginationPop">
            <b-row v-if="lastPage>1">
              <b-colxx xxs="12">
                <b-pagination-nav
                  v-model="page"
                  @input="linkGen()"
                  :number-of-pages="perPage"
                  base-url="#"
                  align="center"
                >
                  <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                  </template>
                  <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                  </template>
                  <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                  </template>
                  <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                  </template>
                </b-pagination-nav>
              </b-colxx>
            </b-row>
          </div>
        </b-modal>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import { apiUrl, xtools } from '@/constants/config'

import linq from 'js-linq'
const $linq = function (arr) {
  return linq.from(arr)
}
export default {
  components: {
    vSelect
  },
  data () {
    return {
      skip: 0,
      dataOld: [],
      account_code: '',
      page: 1,
      perPage: 4,
      search: '',
      from: 0,
      to: 0,
      total: 0,
      lastPage: 15,
      limitPage: 20,
      search: '',
      modalShow: false,
      fromWh: { value: 'dc_account.account_name', label: 'Account Name' },
      dataaccount: [],
      selectFrom: [
        { value: 'dc_account.account_code', label: 'Account Code' },
        { value: 'dc_account.account_name', label: 'Account Name' }
      ]
    }
  },
  methods: {
    onloadSearch(){
      this.page = 1;
      this.onloadaccount()
    },
    linkGen () {
      this.onloadaccount()
    },
    onModalShow (arr_old) {
      this.dataOld = arr_old
      this.modalShow = true
      this.linkGen()
    },
    onModalReturn (row) {
      this.$emit('ct-data-click', { data: row, wh: 'account' })
      this.modalShow = false
    },
    async onloadaccount () { // โหลด store
      this.skip = ((this.limitPage * this.page) - this.limitPage) || 0
      var form = new FormData()
      form.append('from', this.fromWh.value)
      form.append('search', this.search)
      form.append('skip', (this.limitPage * this.page) - this.limitPage)
      form.append('take', this.limitPage)

      let data = await xtools.postServerForm('AccountingforLabor/Master/account_Items_Read', form)
      // this.storeloading = false;
      this.dataaccount = data.data.data || []
      this.dataaccount.forEach((v, i) => {
        v.select = $linq(this.dataOld).where(x => x.dc_account == v.account_code).toArray().length
      })
      // this.perPage = ((data.data.length / this.limitPage) < 0)?1:(data.data.length / this.limitPage);
      this.perPage = (data.data.total / this.limitPage) + 1
    }
  },
  mounted () {

  }
}
</script>
<style scoped>

 .tableMain{
  width:100%;
}
.btn-group > .btn:first-child {
    margin-left: 0;
    width: 100%;
}

.modal-dialog {
    max-width: 80%;
    height: 75vh;
    display: flex;
}
.v-select .dropdown-toggle {
    -moz-appearance: none;
    appearance: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 0 0px;
    white-space: normal;
    height: 37px !important;
}

.tableMain {
    color: #333;
    width: 640px;
    border-collapse:
    collapse; border-spacing: 0;
    width: 100%;
}




.classSelect{
    background: #CFD8DC !important;
    color: #000 !important;
}
</style>
